import axios from '@/common/axios'
import {
  COMMON
} from '../constants/funcUrl'

/**
 * 公共类
 */
const commonAction = {
  // 欢迎
  getModule: ({
    commit
  }, params) => {
    return commit(COMMON.LOCALMODULE, params);
  },
  // 登录
  login: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.LOGIN, params);
  },
  // 课程报名
  getCourses: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COURSE, params);
  },
  // 课程详情
  getCourseDetails: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.COURSEDETAILS, params);
  },
  // 课程报名岗位
  getCourseOpenJobs: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COURSEOPENJOBS, params);
  },
  // 查询证书
  getCertSearch: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.CERTSEARCH, params);
  },
  getEnterpriseRegistration: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.GETENTERPRISEREGISTRATION, params);
  },
  // 学历列表
  getEmployeeDegree: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.EMPLOYEEDEGREE, params);
  },
  // 技术职称列表
  getEmployeeTitle: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.EMPLOYEETITLE, params);
  },
  // 证书类别
  getCertClass: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.CERTCLASS, params);
  },
  // 证书子类
  getCertSubClass: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.CERTSUBCLASS, params);
  },
  // 根据课程标识查询专业列表
  getCourseJobs: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.JOB, params);
  },
  // 企业课程报名详细信息
  getLearnLearnDetails: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.LEARNLEARNDETAILS, params);
  },
  // 企业课程报名审核过程信息
  getLearnLearnApproveStep: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.LEARNLEARNAPPROVESTEP, params);
  },
  // 课程报名缴费方式
  getCommonLearnPayMethod: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONLEARNPAYMETHOD, params);
  },
  // 补考报名缴费方式
  getCommonMakeUpPayMethod: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONMAKEUPPAYMETHOD, params);
  },
  // 企业补考报名详细信息
  getMakeUpMakeUpDetails: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.MAKEUPMAKEUPDETAILS, params);
  },
  // 企业补考报名审核过程信息
  getMakeUpMakeUpApproveStep: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.MAKEUPMAKEUPAPPROVESTEP, params);
  },
  // 企业注册验证码
  postSendverifyCode: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.SENDVERIFYCODE, params);
  },
  // 查询通知公告列表
  getNews: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.NEWS, params, {requestBase: 'dotnet8'});
  },
  // 查询通知公告详情
  getNewsDetails: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.NEWSDETAILS, params, {requestBase: 'dotnet8'});
  },
  // 查询考试安排列表
  getNewsTestPlans: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.NEWSTESTPLANS, params, {requestBase: 'dotnet8'});
  },
  // 发送修改密码短信验证码
  postSendChangePwdVerifycode: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.SENDCHANGEPWDVERIFYCODE, params);
  },
  // 修改密码
  putChangePassword: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, COMMON.CHANGEPASSWORD, params);
  },
  // 首页课程推荐
  getCourseRecommends: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COURSERECOMMEND, params);
  },
  // 查询学习管理列表中的课程报名详细信息
  getLearningmgtDetails: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.LEARNINGMGTDETAILS, params);
  },
  // 验证T
  getVerifyTcaptchaticket: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.VERIFYTCAPTCHATICKET, params);
  },
  getCommonJob: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONJOB, params);
  },
  // 上传图片
  postUploadPic: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.COMMONUPLOADPIC, params);
  },
  // 上传文件
  postUploadFile: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.COMMONUPLOADFILE, params);
  },
  // 查询学习记录
  getStudyRecordDetails: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.STUDYRECORDDETAILS, params);
  },
  // 查询开票申请详情
  getInvoiceApproveDetails: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.INVOICEAPPROVEADETAILS, params);
  },
  getQuickComments: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONQUICKCOMMENTS, params);
  },
  getWeiXinTmpQrCode: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.WEIXINTMPQRCODE, params);
  },
  // 订单发票类型
  getInvoiceTypes: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONINVOICETYPES, params);
  },
  // 订单发票类型
  getInvoicePayBodys: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONINVOICEPAYBODYS, params);
  }
}

export default commonAction;



// WEBPACK FOOTER //
// ./src/store/jzjy/actions/commonAction.js